import { render } from "./SignUpModal.vue?vue&type=template&id=6869a6a4"
import script from "./SignUpModal.vue?vue&type=script&lang=js"
export * from "./SignUpModal.vue?vue&type=script&lang=js"

import "./SignUpModal.vue?vue&type=style&index=0&id=6869a6a4&lang=scss"
script.render = render

export default script